import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface FCMTokenRequest {
  fcm_token: string;
  device_type: string;
  patient_id?: string;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationApiService {
  private readonly baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  /**
   * Register FCM token for the current user
   */
  registerFCMToken(data: FCMTokenRequest, patientId?: string): Observable<any> {
    // //console.log(data);
    return this.http.post<any>(`${this.baseUrl}/notifications/fcm-token`, data);
  }
}
